import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

/**
 * Delays preloading of lazy routes until the browser is idle and a short
 * delay has elapsed, reducing main-thread contention during initial load.
 *
 * Routes can opt-in with `data: { preload: true }` or leave it off to
 * defer until the idle window.
 */
@Injectable({ providedIn: 'root' })
export class IdlePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data?.['preload']) {
      return timer(2000).pipe(mergeMap(() => load()));
    }

    return new Observable(subscriber => {
      const callback = () => {
        setTimeout(() => {
          load().subscribe(subscriber);
        }, 5000);
      };

      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(callback);
      } else {
        setTimeout(callback, 4000);
      }
    });
  }
}